import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { FeatureStateType } from "../model/GameModel";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { gsap } from "gsap";
import { FeatureGreenFishControllerEvents } from "./FeatureGreenFishController";
import { FeatureFishFoodControllerEvents } from "./FeatureFishFoodController";
import { FeatureGoldFishControllerEvents } from "./FeatureGoldFishController";
import { FeatureRedFishControllerEvents } from "./FeatureRedFishController";
import { FeaturePurpleFishControllerEvents } from "./FeaturePurpleFishController";
import { FeatureIntroEvents } from "../view/abstract/display/GameFeatureIntro";
import { LoaderEvent } from "@lib/titan2/dist/loader/event/LoaderEvent";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { MainTransitionEvents } from "../view/abstract/display/GameMainTransition";
import { FeatureGreenFishEvents } from "../view/abstract/display/features/greenfish/FeatureGreenFish";
import { FeatureRedFishEvents } from "../view/abstract/display/features/redfish/FeatureRedFish";
import { FeaturePurpleFishEvents } from "../view/abstract/display/features/purplefish/FeaturePurpleFish";
import { FeatureFishFoodEvents } from "../view/abstract/display/features/fishfood/FeatureFishFood";
import { FeatureGoldFishEvents } from "../view/abstract/display/features/goldfish/FeatureGoldFish";
export class FeatureTransitionController extends AbstractGameController {
    constructor() {
        super(...arguments);
        this.loaderClosed = false;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureTransitionEvents.TRANSITION_TO_GREEN_FISH, this.handleTransitionToGreenFish);
        this.registerGame(FeatureTransitionEvents.TRANSITION_TO_RED_FISH, this.handleTransitionToRedFish);
        this.registerGame(FeatureTransitionEvents.TRANSITION_TO_PURPLE_FISH, this.handleTransitionToPurpleFish);
        this.registerGame(FeatureTransitionEvents.TRANSITION_TO_FISH_FOOD, this.handleTransitionToFishFood);
        this.registerGame(FeatureTransitionEvents.TRANSITION_TO_GOLD_FISH, this.handleTransitionToGoldFish);
        this.registerGame(FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME, this.handleTransitionBackToBaseGame);
        this.registerGame(FeatureTransitionEvents.TRANSITION_FEATURE_SELECTOR, this.transitionToFeatureSelector);
        this.registerGame(LoaderEvent.LOADER_REMOVE, this.handleLoaderRemove);
    }
    handleLoaderRemove() {
        this.loaderClosed = true;
    }
    async transitionToFeatureSelector() {
        if (this.loaderClosed) {
            await this.delayFor(0.25);
        }
    }
    async transitionToFeatureCommon() {
        this.dispatchGame(MainTransitionEvents.TRANSITION_INTRO_START);
        await this.blockUntil(MainTransitionEvents.TRANSITION_INTRO_COMPLETE);
        await this.delayFor(0.5);
        this.dispatchGame(FeatureIntroEvents.FADE_IN);
        if (Service.isReplay()) {
            await (this.delayFor(3));
        }
        else {
            await this.blockUntil(FeatureIntroEvents.CONTINUE);
        }
        this.dispatchGame(FeatureIntroEvents.HIDE);
    }
    async transitionToFeaturePostPresentCommon() {
        this.dispatchGame(MainTransitionEvents.TRANSITION_OUTRO_START);
        await this.blockUntil(MainTransitionEvents.TRANSITION_OUTRO_COMPLETE);
    }
    async handleTransitionToGreenFish() {
        await this.transitionToFeatureCommon();
        this.dispatchGame(FeatureGreenFishEvents.FEATURE_PRESENT);
        await this.transitionToFeaturePostPresentCommon();
        this.dispatchGame(FeatureGreenFishControllerEvents.BEGIN_FEATURE);
    }
    async handleTransitionToRedFish() {
        await this.transitionToFeatureCommon();
        this.dispatchGame(FeatureRedFishEvents.FEATURE_PRESENT);
        await this.transitionToFeaturePostPresentCommon();
        this.dispatchGame(FeatureRedFishControllerEvents.BEGIN_FEATURE);
    }
    async handleTransitionToPurpleFish() {
        await this.transitionToFeatureCommon();
        this.dispatchGame(FeaturePurpleFishEvents.FEATURE_PRESENT);
        await this.transitionToFeaturePostPresentCommon();
        this.dispatchGame(FeaturePurpleFishControllerEvents.BEGIN_FEATURE);
    }
    async handleTransitionToFishFood() {
        await this.transitionToFeatureCommon();
        this.dispatchGame(FeatureFishFoodEvents.FEATURE_PRESENT);
        const chanceGameData = this.model.getFishFoodChanceGameData();
        this.dispatchGame(new EventObject(FeatureFishFoodEvents.SET_PRIZE_VALUES.getType(), { prizes: chanceGameData.getPrizes() }));
        await this.transitionToFeaturePostPresentCommon();
        this.dispatchGame(FeatureFishFoodControllerEvents.BEGIN_FEATURE);
    }
    async handleTransitionToGoldFish() {
        await this.transitionToFeatureCommon();
        this.dispatchGame(FeatureGoldFishEvents.FEATURE_PRESENT);
        await this.transitionToFeaturePostPresentCommon();
        this.dispatchGame(FeatureGoldFishControllerEvents.BEGIN_FEATURE);
    }
    async handleTransitionBackToBaseGame() {
        this.model.setFeatureState(FeatureStateType.COLLECTED);
        this.dispatchGame(MainTransitionEvents.BLACKOUT_START);
        await this.blockUntil(MainTransitionEvents.BLACKOUT_MID_POINT);
        this.dispatchGame(SlingoEvent.WIN_DISPLAY_START);
        await this.blockUntil(MainTransitionEvents.BLACKOUT_COMPLETE);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME_COMPLETE);
        console.log("Transition to base-game Complete");
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, () => {
                this.unregisterGame(event);
                resolve();
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
}
export class FeatureTransitionEvents {
}
FeatureTransitionEvents.TRANSITION_TO_GREEN_FISH = new EventObject("FeatureTransitionEvents.TRANSITION_TO_GREEN_FISH");
FeatureTransitionEvents.TRANSITION_TO_RED_FISH = new EventObject("FeatureTransitionEvents.TRANSITION_TO_RED_FISH");
FeatureTransitionEvents.TRANSITION_TO_PURPLE_FISH = new EventObject("FeatureTransitionEvents.TRANSITION_TO_PURPLE_FISH");
FeatureTransitionEvents.TRANSITION_TO_FISH_FOOD = new EventObject("FeatureTransitionEvents.TRANSITION_TO_FISH_FOOD");
FeatureTransitionEvents.TRANSITION_TO_GOLD_FISH = new EventObject("FeatureTransitionEvents.TRANSITION_TO_GOLD_FISH");
FeatureTransitionEvents.TRANSITION_FEATURE_SELECTOR = new EventObject("FeatureTransitionEvents.TRANSITION_TO_FEATURE_SELECTOR");
FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME = new EventObject("FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME");
FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME_COMPLETE = new EventObject("FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME_COMPLETE");
FeatureTransitionEvents.TRANSITION_WIN_PARTICLE = new EventObject("FeatureTransitionEvents.TRANSITION_WIN_PARTICLE");
//# sourceMappingURL=FeatureTransitionController.js.map